import { render } from "./user_item.vue?vue&type=template&id=ca67a2c8&scoped=true"
import script from "./user_item.vue?vue&type=script&lang=js"
export * from "./user_item.vue?vue&type=script&lang=js"

import "./user_item.vue?vue&type=style&index=0&id=ca67a2c8&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca67a2c8"]])

export default __exports__